function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  rx: 17,
  fill: "#F2F2F7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4434 11.5449L23.3301 10.4316C22.9785 10.0801 22.4805 9.875 22.0117 9.875C21.543 9.875 21.0449 10.0801 20.6934 10.4316L18.7012 12.4238L17.5293 11.2812C17.0898 10.8125 16.3281 10.8125 15.8887 11.2812L12.4023 14.7383C12.2266 14.9434 12.2266 15.2363 12.4023 15.4121L12.7246 15.7344C12.9004 15.9102 13.2227 15.9102 13.3984 15.7344L16.709 12.4238L17.7051 13.4199L17.5 13.625L12.7246 18.4004C11.4355 19.6895 10.2051 22.2676 10 24.1133C9.94141 24.5234 10.2637 24.875 10.6738 24.875C10.7031 24.875 10.7324 24.875 10.7617 24.875C12.6074 24.6699 15.1855 23.4395 16.4746 22.1504L21.25 17.375L22.2461 16.3789L24.4434 14.1816C25.1758 13.4492 25.1758 12.2773 24.4434 11.5449ZM15.5078 21.1543C14.4238 22.2383 13.0469 22.9707 11.5527 23.3223C11.9043 21.8281 12.6367 20.4512 13.7207 19.3672L18.4668 14.6211L18.7012 14.416L20.459 16.1738L20.2539 16.4082L15.5078 21.1543ZM23.4473 13.1855L21.4551 15.1777L20.0195 13.7422L19.6973 13.4199L21.6895 11.4277C21.8066 11.3105 21.9531 11.2812 22.0117 11.2812C22.0703 11.2812 22.2168 11.3105 22.334 11.4277L23.4473 12.541C23.5645 12.6582 23.5645 12.8047 23.5645 12.8633C23.5645 12.9219 23.5645 13.0684 23.4473 13.1855Z",
  fill: "#141233"
});

var SvgManual = function SvgManual(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManual, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manual.22d861db.svg";
export { ForwardRef as ReactComponent };